module.exports = __webpack_public_path__ + "static/media/clock.8b785a8d.svg";